module.exports = {
    idCompany: 123,
    "companyName": "Xpressdocs DEMO",
    "companyPhone1": "",
    "companyPhone2": "",
    "companyEmail": "srowe@xpressdocs.com",
    "companyFax": "",
    companyId: "123",
    "companyWebsite": "",
    "companyAddress1": "4901 N Beach St",
    "companyAddress2": "",
    "companyCity": "Fort Worth",
    "companyState": "TX",
    "companyCountry": "US",
    "companyZip": "76137",
    "companySupportPhone": "",
    "companySupportEmail": "",
    "companyAdminEmail1": "srowe@xpressdocs.com",
    "companyAdminName1": "Eric Arnold",
    "companyAdminPhone1": "817.111.0000",
    "companyManagerEmail": "eric@xpressdocs.com",
    "companyManagerName": "Eric Arnold",
    "companyManagerPhone": "1.866.977.3627 ext 205",
    "companyCustom1": "",
    "companyCustom2": "",
    "companyNameSugComments": "",
    "addressListTypes": "upload,radius,street",
    "displayFields": {
        "1": "Name",
        "2": "Title",
        "3": "Email",
        "4": "Phone 1",
        "5": "Phone 2",
        "6": "Phone 3",
        "7": "Website",
        "8": "Social Media"
    },
    profile: {
        "displayLabelData1": "Name",
        "displayLabelData2": "Title",
        "displayLabelData3": "Email",
        "displayLabelData4": "Phone 1",
        "displayLabelData5": "Phone 2",
        "displayLabelData6": "Phone 3",
        "displayLabelData7": "Website",
        "displayLabelData8": "Social Media",
        "displayLine1": "1",
        "displayLine2": "1",
        "displayLine3": "1",
        "displayLine4": "1",
        "displayLine5": "1",
        "displayLine6": "1",
        "displayLine7": "1",
        "displayLine8": "1",
        "newYorkSalesTax": "1",
        "branchEditDisplay": "1",
        "branchEditAgentDisplay": "1"
    },
    featureFlags: {},
    "prefs": {
        defaultOrResident: true,
        enableCutoutPro: true,
        enableVouchers: true,
        adBudgetEnable: true,
        enableMapBasedMailingSupport: true,
        agentEditDisplay: true,
        // agentCanEditHeadshot: true,
        allowPromoCodes: true,
        agentCanEditHeadshot: true,
        enableScheduledOrder: true,
        "hideCompanyLevelPricing": false,
        "hideBranchLevelPricing": false,
        "hideAgentLevelPricing": false,
        "allowUserLevelAllListingsSearch": 0,
        allowSocialMediaAccMngtAgent: false,
        allowSocialMediaAccMngtCompany: false,
        allowSocialMediaAccMngtBranch: false,

        // allowShipToBranch: 1,
        allowShipToBranch: 0,
        enableInformedDelivery: true,
        // enableInformedDelivery: false,

        allowBulkMailPermit: true,
        allowFaceBookOnSocialMediaAccMngt: true,
        allowTwitterOnSocialMediaAccMngt: true,
        allowLinkedinOnSocialMediaAccMngt: true,
        "hideCreditCardCollection": 0,
        // "hideCreditCardCollection": 1,
    },
};

const aa = {
    "idCompany": "d2dbadb1",
    "idUser": 1359983,
    "idBrand": "5F5EE45B39",
    "idLasso": "",
    "companyAddress1": "1301 NE Loop 820",
    "companyAddress2": "",
    "companyAdminEmail1": "gfl_mtoropov@xpressdocs.com",
    "companyAdminName1": "Admin Adminington",
    "companyAdminPhone1": "",
    "companyAutoemailAddress": "",
    "companyCity": "Fort Worth",
    "companyState": "TX",
    "companyCountry": "USA",
    "companyZip": "76131",
    "companyEmail": "gfl_mtoropov@xpressdocs.com",
    "companyFax": "",
    "companyIdentifier": "",
    "companyManagerEmail": "gfl_mtoropov@xpressdocs.com",
    "companyManagerName": "Manage van Manager",
    "companyManagerPhone": "",
    "companyName": "Acme Demonstration Site - Xpresso",
    "companyNameSugComments": "",
    "companyPhone1": "866.977.3627",
    "companyPhone2": "",
    "companyShippingAddress1": "4901 N Beach Street",
    "companyShippingAddress2": "",
    "companyShippingCity": "Fort Worth",
    "companyShippingState": "TX",
    "companyShippingZip": "76137",
    "companyActive": 1,
    "companyBrandName": "",
    "companyIndustryName": "RRE",
    "companyWebsite": "",
    "companyShippingCountry": "US",
    "launchDate": null,
    "oiaLaunchDate": null,
    "idIndustry": "",
    "companyXdocsUrl": "acmexpresso",
    "companyXdocsUrlBranch": "",
    "companySupportEmail": "info@xpressdocs.com",
    "companySupportPhone": "(866) 977-3627",
    "companySchemeCodeId": "1f25ca6012",
    "prefs": {
        "upgrade": 0,
        "upgradeDate": {
            "date": "-0001-11-30 00:00:00.000000",
            "timezone_type": 3,
            "timezone": "America/Chicago"
        },
        "agentCount": 0,
        "flowthru": 1,
        "createBranch": 1,
        "updateBranch": 1,
        "createAgent": 1,
        "agentIndependent": 0,
        "companyCustom1": "",
        "companyCustom2": "",
        "companyCourierAvailable": 1,
        "companyAllowInvoice": 1,
        "companyVersion1Id": "",
        "companyRegistrationCode": "",
        "companyUserRegistration": 0,
        "branchCustomLabel1": "",
        "branchCustomLabel2": "",
        "companyBranchConfirm": 1,
        "billingOverride": 1,
        "addressListTypes": [
            "upload",
            "radius",
            "street",
            "saturation",
            "co-op/condo building",
            "targeted single",
            "targeted multiple"
        ],
        "reviewOrders": 0,
        "logoClr1": "",
        "logoBw1": "",
        "logoClr2": "",
        "logoBw2": "",
        "loginText": null,
        "orderConfirmationsTo": "user_level",
        "allowLogoUpload": 1,
        "allowShipToBranch": 1,
        "uvCharge": "1",
        "enableUvSide2": 1,
        "agentEditBranch": 0,
        "downloadProductionPdf": 0,
        "enableVouchers": 1,
        "branchDnm": 0,
        "enableStandardMail": 1,
        "defaultMailClass": "3",
        "landingPwRetrieve": 0,
        "intranetName": "",
        "retrieveSearch": "",
        "allowSignup": 0,
        "vhtPhotos": 0,
        "allowBranchCreate": 0,
        "loginInstructions": "",
        "allowPromoCodes": "0",
        "showPricingLink": 1,
        "orderConfirmationsSubjectPrefix": "",
        "receiptLogo": "",
        "emailActive": 0,
        "allowNewProofing": 1,
        "allowPdfPurchase": 1,
        "totalSourceCharge": 1,
        "showReceipt": 1,
        "uvChargeSide1Buscard": 1,
        "uvChargeSide2Buscard": 1,
        "allowPdfUpload": 1,
        "enableLicenseNumber": 2,
        "promoLogoLandscape": "",
        "promoLogoPortrait": "",
        "allowDomainSpecificEmail": 0,
        "specificEmailDomain": "",
        "displayWelcomeMessage": 0,
        "logoBw1Asset": null,
        "logoClr1Asset": null,
        "logoBw2Asset": null,
        "logoClr2Asset": null,
        "logoBw3Asset": null,
        "logoClr3Asset": null,
        "enableLoadOfficeAddress": true,
        "idAcctManager": "19",
        "cmsUpdate": null,
        "enableNewXpresslinks": true,
        "regPromotion": "",
        "regPostscript": "",
        "pdfPrice": null,
        "allowPdfPreview": true,
        "enablePromotionalProducts": false,
        "agentEditDisplay": true,
        "agentFlowthruAutoUpdate": true,
        "templatePermissionType": null,
        "allowWelcomeEmail": true,
        "fasttracEnableTab": false,
        "fasttracCostCenterId": "",
        "fasttracBillingCostCenterId": null,
        "fasttracDebtorCode": "",
        "fasttracSharedSecret": "",
        "fasttracPunchoutUrl": "",
        "pdfDownloadLabel": "",
        "adBudgetEnable": true,
        "adBudgetAccount": "b98d165f",
        "googleAnalyticsTrackerCode": "",
        "promoProductsUrl": "xpressdocs.boundlesspromotion.com",
        "enableAssetManager": false,
        "hideCreditCardCollection": 0,
        "avalaraCompanyCode": "DEFAULT",
        "avalaraUsageType": "",
        "enableRequestAQuote": true,
        "enableLiveChat": true,
        "showSeasonal": true,
        "photoService": true,
        "enableXpresslinks": true,
        "allowDeliveryMethodDownload": true,
        "allowLowQualityPhotosProperty": true,
        "styleIdLowQualityPhotosExceptionsProperty": "",
        "productIdLowQualityPhotosExceptionsProperty": "",
        "categoryIdLowQualityPhotosExceptionsProperty": "",
        "programIdLowQualityPhotosExceptionsProperty": "",
        "allowLowQualityPhotosLogo": true,
        "styleIdLowQualityPhotosExceptionsLogo": "",
        "productIdLowQualityPhotosExceptionsLogo": "",
        "categoryIdLowQualityPhotosExceptionsLogo": "",
        "programIdLowQualityPhotosExceptionsLogo": "",
        "allowLowQualityPhotosHeadshot": true,
        "styleIdLowQualityPhotosExceptionsHeadshot": "",
        "productIdLowQualityPhotosExceptionsHeadshot": "",
        "categoryIdLowQualityPhotosExceptionsHeadshot": "",
        "programIdLowQualityPhotosExceptionsHeadshot": "",
        "enableNcoa": true,
        "nonProfitStatus": false,
        "allowPhotoGallery": true,
        "allowLogoGallery": false,
        "allowDesignationGallery": false,
        "allowQrGallery": false,
        "userMeta1Label": "",
        "userMeta1Level": "company",
        "userMeta2Label": "",
        "userMeta2Level": "company",
        "allowPhotoEditor": true,
        "strregRequireBranch": false,
        "billingServiceId": "default",
        "billingServiceLabel": "Xpressdocs",
        "companyBrandedHeader": "",
        "companyBrandedHeaderLink": "",
        "companyBrandedFooter": "1853709235testfooter.jpg",
        "companyBrandedFooterLink": "",
        "brandedLandingPageCheckbox": true,
        "fontFamily": "",
        "fontSize": "",
        "fontColor": "",
        "fontFamilyDesc": "",
        "fontSizeDesc": "",
        "fontColorDesc": "",
        "fontFamilyContact": "",
        "fontSizeContact": "",
        "fontColorContact": "",
        "enableShippedProductWithMailOrder": true,
        "enableSocialmadesimple": false,
        "signupMessage": null,
        "signupButtonLabel": null,
        "signupLink": null,
        "signupMessageTitle": null,
        "strregDefaultBranch": "",
        "sampleAddressName2Override": "",
        "xlinksHeadline": "Thought You'd be Interested",
        "xlinksDescription": "                                                                                                                                                                                                                                                                                                                                                                                        Here you can add additional information not included in your print campaign (e.g., neighborhood, school, proximity to bus, amenities, etc.) This is especially important if users will access this page from a QR code on your DM piece, as it rewards that effort. Simply replace this text with your own. If you do not want to include text in this area, un-check the \"Active\" checkbox above this field and click \"Save & Apply\" at the top of the page.                                                                                                                                                                                                                                                                                                                                                                                        ",
        "xlinksContact": "Contact me today for more information about this home or to schedule an appointment. I can also provide information about other homes for sale in this neighborhood and surrounding areas. If you're just starting your search, we can schedule a no-obligation buyer's consultation to answer questions and help you determine the right budget for your new home. I can also provide a complimentary Comparative Market Analysis if you're considering selling your home.                                                                                                                                                                                                                                                                                                                                                                                        ",
        "xlinksCategory": "Real Estate",
        "xlinksAgentHeadshot1": "",
        "xlinksAgentName1": "[ENTER TEXT HERE]",
        "xlinksAgentAddress1": "[ENTER TEXT HERE]",
        "xlinksAgentCity1": "[ENTER TEXT HERE]",
        "xlinksAgentState1": "[ENTER TEXT HERE]",
        "xlinksAgentZipcode1": "[ENTER TEXT HERE]",
        "xlinksAgentEmail1": "[ENTER TEXT HERE]",
        "xlinksAgentPhone1": "[ENTER TEXT HERE]",
        "xlinksAgentFax1": "[ENTER TEXT HERE]",
        "xlinksAgentField81": "[ENTER TEXT HERE]",
        "xlinksAgentHeadshot2": "",
        "xlinksAgentName2": "[ENTER TEXT HERE]",
        "xlinksAgentAddress2": "[ENTER TEXT HERE]",
        "xlinksAgentCity2": "[ENTER TEXT HERE]",
        "xlinksAgentState2": "[ENTER TEXT HERE]",
        "xlinksAgentZipcode2": "[ENTER TEXT HERE]",
        "xlinksAgentEmail2": "",
        "xlinksAgentPhone2": "[ENTER TEXT HERE]",
        "xlinksAgentFax2": "[ENTER TEXT HERE]",
        "xlinksAgentField82": "[ENTER TEXT HERE]",
        "xlinksAgentHeadshot3": "",
        "xlinksAgentName3": "[ENTER TEXT HERE]",
        "xlinksAgentAddress3": "[ENTER TEXT HERE]",
        "xlinksAgentCity3": "[ENTER TEXT HERE]",
        "xlinksAgentState3": "[ENTER TEXT HERE]",
        "xlinksAgentZipcode3": "[ENTER TEXT HERE]",
        "xlinksAgentEmail3": "",
        "xlinksAgentPhone3": "[ENTER TEXT HERE]",
        "xlinksAgentFax3": "[ENTER TEXT HERE]",
        "xlinksAgentField83": "[ENTER TEXT HERE]",
        "enableVoucherNotifications": true,
        "internationalMailing": false,
        "fedexShippingServices": "all",
        "showMagnet": false,
        "mediumQualityHeadshotDisclaimer": false,
        "emailNewActive": false,
        "displayPromotionalProductsTab": false,
        "seasonalDefaultIdOverride": "",
        "enableEmailToUsersOld": null,
        "agentFlowthruAutoMove": true,
        "autoActivateBranch": true,
        "autoActivateAgent": true,
        "allowEditLinkId": false,
        "rezoraUrl": "",
        "rezoraSalt": "",
        "maxActiveListingAge": 180,
        "maxNumListingImages": 10,
        "host": null,
        "fileName": "",
        "lastRunDate": null,
        "status": null,
        "emailField": null,
        "matchOn": null,
        "companyXdocsLandingPage": "",
        "allowAddListing": true,
        "calendar": false,
        "signupCreateAgent": true,
        "signupCreateBranch": true,
        "maxSoldListingAge": 180,
        "maxListingAgeForExport": 0,
        "agentOfficeBatchImportEnabled": false,
        "feedDrivenAccessKeys": null,
        "licenseNumberLabel": "",
        "uspsMailerId": "",
        "enableTemplateKeywordSearch": true,
        "enableManageAdmins": true,
        "enableListingDateSold": false,
        "enableMyListing": true,
        "enableTroubleshootingAccess": false,
        "orderCleanupNotificationLevel": "agent",
        "orderFulfilmentBillingId": "24f2e40c",
        "orderFulfilmentUserName": null,
        "orderFulfilmentPassword": null,
        "enableOrderFulfilment": true,
        "mailingOrderFulfilment": true,
        "shippingOrderFulfilment": true,
        "enableScheduledOrder": true,
        "idPriceGrid": 1,
        "enablePreviousOrderHistory": false,
        "enableUsernameEmailLogin": true,
        "enableGoogleIdLogin": true,
        "enableMetaIdLogin": true,
        "enablePhoneNumberLogin": false,
        "enableCaptchaOnCreateUser": false,
        "enableCaptchaOnSupportForm": true,
        "emailTracking": true,
        "enableShippingOrderFulfillmentNotification": true,
        "enableMailingOrderFulfillmentNotification": false,
        "enablePickupOrderFulfillmentNotification": true,
        "hasFulfillmentApiValidateShippingAddress": false,
        "importingListingPhotosWithMyListings": true,
        "allowUserLevelAllListingsSearch": 0,
        "allowBulkMailPermit": true,
        "defaultOrderApprovalPermission": null,
        "customInactiveUserMessage": "",
        "enableEpmValidation": true,
        "showPrintDirectMail": false,
        "enableShippingMinmaxOverride": true,
        "ofaAllowTransactionInformation": true,
        "downloadOrderFulfilment": true,
        "ofaCreateAgent": true,
        "ofaCreateBranch": true,
        "ofaCreateRegion": false,
        "ofaSkipBranchAgent": false,
        "ofaDisableOrderConfirmationEmail": true,
        "requiresClientShippingAccount": false,
        "apmMaxListingAge": 180,
        "apmMaxSoldListingAge": 180,
        "allowBreakConsolidation": true,
        "newOfficeEmailNotification": true,
        "failRequestsByCassFailureLevel": false,
        "hideNoneBillingOption": false,
        "finishingDelay": null,
        "ofaUyoPdfPageSizeValidation": false,
        "hideShippingPrice": false,
        "allowedCcTypes": "all",
        "allowShippingConsolidationOnCheckout": true,
        "assignedDomain": "@acme.com",
        "domainWrap": 0,
        "crmDomain": "",
        "crmAppKey": "",
        "orderLimitation": false,
        "allowPreviousOrderShipping": true,
        "displaySecurityQuestions": false,
        "crmUse": "single",
        "allowEditCostCenter": false,
        "dynamicAccount": false,
        "ofaPdfValidation": false,
        "requireCustomPackingSlip": false,
        "customPackingSlipApi": "",
        "clientShippingAccountApi": "",
        "enableReorderExternalOrder": false,
        "xpressoKitOptionsActive": false,
        "allowBuild3": true,
        "agentCanEditHeadshot": 0,
        "agentCanEditLogos": 1,
        "officeCanEditHeadshot1": 0,
        "officeCanEditLogos": 1,
        "mailingIndicia": "XD_Indicia",
        "turnOffCassValidation": false,
        "watermarkWO": "",
        "addMailingDesignation": 0,
        "enableClientMailStatusTracking": 1,
        "convertAddressUppercase": 1,
        "hideCompanyLevelPricing": false,
        "hideBranchLevelPricing": false,
        "hideAgentLevelPricing": false,
        "moxiworksCompanyId": "",
        "moxiworksUseAgentId": false,
        "moxiworksOwnerName": "contact_name",
        "enableCanadaMailing": true,
        "crmServiceDomain1": "",
        "crmServiceDomain2": "",
        "crmServiceDomain3": "",
        "crmUserName": "",
        "crmPassword": "",
        "crmHttpMethod": "POST",
        "phoneFormat": "0",
        "intlPhoneFormat": "0",
        "customersCanvasUsesDefaultAssetManager": false,
        "allowSocialMediaAccMngtCompany": true,
        "allowSocialMediaAccMngtBranch": true,
        "allowSocialMediaAccMngtAgent": true,
        "allowFaceBookOnSocialMediaAccMngt": true,
        "allowTwitterOnSocialMediaAccMngt": true,
        "allowLinkedinOnSocialMediaAccMngt": true,
        "smartTemplateIcon": true,
        "enableCutoutPro": true,
        "enableMarketingCenter": true,
        "enableSubscriptions": true,
        "enableUserCreatedTemplates": true,
        "autoCreateRegion": true,
        "autoUpdateRegion": true,
        "suggestedCommentsMode": 2,
        "autoActivateAdBudget": false,
        "allowAddressListDownload": true,
        "enableGuestCheckout": true,
        "loginLevelControl": "sso",
        "includeUyoPdfGuide": true,
        "hasTaxIndemnificationAgreement": true,
        "allowEditBranchLinkID": true,
        "allowEditAgentLinkID": false,
        "showXDPlusTile": true,
        "enableMapBasedMailingSupport": true,
        "emailToUsersSelection": "No",
        "salesStaffName": "AMST "
    },
    "exclusiveContent": {
        "enableExclusiveContent": false,
        "exclusiveContentFilterType": null,
        "filterTag": "",
        "filterJson": null
    },
    "displayFields": {
        "1": "Name",
        "2": "Title",
        "3": "Email",
        // "4": "Phone 1",
        // "5": "Phone 2",
        // "6": "Phone 3",
        "7": "Website",
        "8": "Social Media"
    },
    "profile": {
        "displayLabelData1": "Name",
        "displayLabelData2": "Title",
        "displayLabelData3": "Email",
        "displayLabelData4": "Phone 1",
        "displayLabelData5": "Phone 2",
        "displayLabelData6": "Phone 3",
        "displayLabelData7": "Website",
        "displayLabelData8": "Social Media",
        "displayLine1": "1",
        "displayLine2": "1",
        "displayLine3": "1",
        "displayLine4": "1",
        "displayLine5": "1",
        "displayLine6": "1",
        "displayLine7": "1",
        "displayLine8": "1",
        "newYorkSalesTax": "1",
        "branchEditDisplay": "1",
        "branchEditAgentDisplay": "1"
    },
    "imageGallery": {
        "dynamicLogos": [],
        "designations": [
            {
                "name": "BBB",
                "id": 22326917,
                "imageUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/11/22326917.jpg",
                "thumbnailUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/9/22326917.jpg"
            },
            {
                "name": "Facebook",
                "id": 22326918,
                "imageUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/11/22326918.jpg",
                "thumbnailUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/9/22326918.jpg"
            },
            {
                "name": "Twitter",
                "id": 22326920,
                "imageUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/11/22326920.jpg",
                "thumbnailUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/9/22326920.jpg"
            },
            {
                "name": "YouTube",
                "id": 22326921,
                "imageUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/11/22326921.jpg",
                "thumbnailUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/9/22326921.jpg"
            },
            {
                "name": "Wordpress",
                "id": 22326922,
                "imageUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/11/22326922.jpg",
                "thumbnailUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/9/22326922.jpg"
            },
            {
                "name": "MAINT-18993 UPD5",
                "id": 31640264,
                "imageUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/11/31640264.jpg",
                "thumbnailUrl": "https://assets.awsdev.xpressdocs.com/dserv/p/9/31640264.jpg"
            }
        ]
    },
    "logos": [],
    "orgPrefs": [],

    featureFlags: {},
};
